<template>
    <div class="c-o-my-pages-section">
        <div class="c-o-my-pages-section__inner">
            <div class="c-o-my-pages-section__message" v-if="errorMessages.length > 0">
                <message type="error">
                    <div class="o-wysiwyg">
                        <ul>
                            <li v-for="(message, index) in errorMessages" :key="`message-${index}`">{{message}}</li>
                        </ul>
                    </div>
                </message>
            </div>
            <h2 class="c-o-my-pages-section__heading">Användaruppgifter</h2>
            <div class="c-o-my-pages-section__form">
                <div
                    class="c-o-my-pages-section__form-block c-o-my-pages-section__form-block--half"
                    :class="{'c-o-my-pages-section__form-block--invalid-animation': errors.name}"
                >
                    <input-field
                        :id="461"
                        v-model="name"
                        name="company-account-name"
                        :label="'Namn'"
                        :invalid="errors.name"
                        :required="true">
                    </input-field>
                </div>
                <div
                    class="c-o-my-pages-section__form-block c-o-my-pages-section__form-block--half"
                    :class="{'c-o-my-pages-section__form-block--invalid-animation': errors.phone}"
                    >
                    <input-field-phone
                        :id="464"
                        v-model="phone"
                        name="company-account-phone"
                        :label="'Telefon'"
                        :placeholder="'Ex. 070-123 45 67'"
                        :invalid="errors.phone"
                        :required="true">
                    </input-field-phone>
                </div>
                <div
                    class="c-o-my-pages-section__form-block c-o-my-pages-section__form-block--half"
                    :class="{'c-o-my-pages-section__form-block--invalid-animation': errors.email}"
                >
                    <input-field-email
                        :id="462"
                        v-model="email"
                        name="company-account-email"
                        :label="'E-post'"
                        :placeholder="'Ex. namn@minhemsida.se'"
                        :invalid="errors.email"
                        :required="true">
                    </input-field-email>
                </div>
                <div class="c-o-my-pages-section__form-block c-o-my-pages-section__form-block--half">
                    <label class="c-o-my-pages-section__form-label">Fakturaadress</label>
                    <p class="u-margin-bottom-0">{{companyData.Name}}</p>
                    <p class="u-margin-bottom-0">{{companyData.Address}}</p>
                    <p class="u-margin-bottom-0">{{companyData.City}}</p>
                </div>
                <div class="c-o-my-pages-section__form-block">
                    <atom-checkbox 
                        :id="468"
                        v-model="newsletter"
                        :label="'Nyhetsbrev'"
                    />
                </div>
            </div>
            <div class="c-o-my-pages-section__save-button">
                <success-button :currentState="saveState" @buttonClicked="save"></success-button>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapActions } from 'vuex';
    import {
        UPDATE_COMPANY_USER_ACCOUNT_INFO,
        SAVE_COMPANY_USER_ACCOUNT_INFO,
        GET_SAVE_ERROR,
    } from '../../../../../../store/store-models/my-pages-company-model';

    import { timeout } from '../../../../../../helpers';
    import { hasErrors, setErrors, isEmailValid, isPhoneValid } from '../../../../../../helpers/error-validation';

    import AtomCheckbox from '../../../../atoms/form/AtomCheckbox.vue'
    import InputField from '../../../../atoms/form/AtomInputText.vue'
    import InputFieldEmail from '../../../../atoms/form/AtomInputEmail.vue'
    import InputFieldPhone from '../../../../atoms/form/AtomInputPhone.vue'
    import SuccessButton from '../../../../atoms/AtomSuccessButton.vue'
    import Message from '../../../../molecules/MoleculeMessage.vue'


    export default {
        props: [
            'userData',
            'companyData'
        ],
        components:{
            InputField,
            AtomCheckbox,
            SuccessButton,
            InputFieldEmail,
            InputFieldPhone,
            Message
        },
        data() {
            return {
                errorMessages: [],
                errors: {
                    name: false,
                    phone: false,
                    email: false
                },
                saveState: 'default'
            }
        },
        computed: {
            saveError: function() {
                return this.$store.getters[GET_SAVE_ERROR]('accountInfo');
            },
            name: {
                get(){
                    return this.userData.Name;
                },
                set(value){
                    this.$store.dispatch(UPDATE_COMPANY_USER_ACCOUNT_INFO, { 'Name': value });
                }
            },
            phone: {
                get(){
                    return this.userData.Phone;
                },
                set(value){
                    this.$store.dispatch(UPDATE_COMPANY_USER_ACCOUNT_INFO, { 'Phone': value });
                }
            },
            email: {
                get(){
                    return this.userData.Email;
                },
                set(value){
                    this.$store.dispatch(UPDATE_COMPANY_USER_ACCOUNT_INFO, { 'Email': value });
                }
            },
            newsletter:{
                get(){
                    return this.userData.Newsletter;
                },
                set(value){
                    this.$store.dispatch(UPDATE_COMPANY_USER_ACCOUNT_INFO, { 'Newsletter': value });
                }
            }
        },
        methods: {
            ...mapActions({
                saveUserData: SAVE_COMPANY_USER_ACCOUNT_INFO
            }),
            async save() {
                this.errorMessages = [];
                setErrors(this.errors, ['name', 'phone', 'email'], false);

                if(!this.name || !this.phone || !this.email) {
                    ['name', 'phone', 'email'].forEach(model => {
                        const value = !this[model] ? true : false;
                        setErrors(this.errors, [model], value);
                    });

                    this.errorMessages.push('Fyll i alla obligatoriska fält')
                }

                if( !isEmailValid(this.email) ) {
                    this.errorMessages.push('Fyll i en korrekt mailadress')
                    setErrors(this.errors, ['email'], true);
                }

                if( !isPhoneValid(this.phone) ) {
                    this.errorMessages.push('Fyll i ett korrekt telefonnummer. (Ex. 070-123 45 67)')
                    setErrors(this.errors, ['phone'], true);
                }

                if( hasErrors(this.errors, ['name', 'phone', 'email']) ) {
                    this.saveState = 'error';
                    return;
                }

                this.saveState = 'processing';

                try {
                    const response = await this.saveUserData();
                    this.saveState = 'success';
                } catch(e) {
                    this.errorMessages.push(this.saveError);
                    this.saveState = 'error';
                }

                await timeout();
                this.saveState = 'default';
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/my-pages-sections/company/account/OrganismMyPagesAccountInfo.vue